<template>
    <v-container fluid class="pt-0 mt-0 d-none d-sm-none d-md-flex">
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        <div>
                            <p class="display-1 font-weight-thin text--primary mt-0">Havi átlagóra</p>
                        </div>
                    </v-card-title>

                    <apexchart width="100%" type="bar" :options="chartOptions" :series="series"></apexchart>

                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "MonthlyAverageTime",

        props: {
            userId: { required: true }
        },

        mounted() {
            this.getAvgHours(this.$route.params.id)
        },

        data () {
            return {
                chartOptions: {
                    chart: { id: 'vuechart-example' },
                    xaxis: { categories: [] }
                },
                series: []
            }
        },

        methods: {
            async getAvgHours(id_user) {
                await this.$axios({ url: `/average/more-monthly-chart/${id_user}/6`, method: 'GET' })
                    .then(resp => {
                        console.log(resp.data.data)
                        this.chartOptions = {
                            xaxis: {
                                categories: resp.data.data.axis
                            }
                        }
                        this.series[0] = {
                            name: 'Átlag munkaidő',
                            data: resp.data.data.series1
                        }
                    })
            }
        }

    }
</script>

<style scoped>

</style>
